import type { LinkProps } from 'next/link';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { ensureLocale } from '@/utils/urlUtils';

import type { ButtonProps } from '@/components/Button';
import { Button } from '@/components/Button';
import { useRouter } from '@/hooks/useRouter';

import LinkWithLocale from './LinkWithLocale/LinkWithLocale';

const Link = styled(LinkWithLocale)`
  text-decoration: none;
`;

type LinkButtonProps = ButtonProps & Pick<LinkProps, 'href' | 'prefetch'>;

export const LinkButton = forwardRef<HTMLElement, LinkButtonProps>(
  ({ href, ...props }, ref) => {
    const { locale } = useRouter();
    const localizedHref = ensureLocale(href, locale);

    return (
      <Button
        // @ts-ignore
        ref={ref}
        as={Link}
        // @ts-ignore
        href={localizedHref}
        {...props}
      />
    );
  },
);

LinkButton.displayName = 'LinkButton';
